import { SearchTaskRequestTaskDue } from '@urbanx/agx.activities.client'
import { TaskFilterState } from 'pages/allTasks/TaskFilters/TaskFiltersState'

export const createTodaysTasksFilterState = (
  assignedToUserIds?: string[],
  agencyIds?: string[]
): TaskFilterState => ({
  states: undefined,
  teamTypes: undefined,
  assignedToUserIds,
  agencyIds,
  stages: undefined,
  taskDue: SearchTaskRequestTaskDue.Today,
})
